<script setup>
import { computed, ref } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();
const dialogRef = ref(null);

// UX hygiene (release-audit C3, corrected): the backend lock + fingerprint
// already reuse the active retry, so this only prevents a redundant second
// request and double alerts while one is in flight.
const uiFlags = useMapGetter('campaigns/getUIFlags');
const isRetrying = computed(() => Boolean(uiFlags.value?.isRetrying));

const handleDialogConfirm = async () => {
  if (!props.selectedCampaign?.id) return;
  if (isRetrying.value) return;

  try {
    await store.dispatch('campaigns/retryFailed', props.selectedCampaign.id);
    useAlert(t('CAMPAIGN.WHATSAPP.RETRY.API.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        t('CAMPAIGN.WHATSAPP.RETRY.API.ERROR_MESSAGE')
    );
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN.WHATSAPP.RETRY.TITLE')"
    :description="t('CAMPAIGN.WHATSAPP.RETRY.DESCRIPTION')"
    :confirm-button-label="t('CAMPAIGN.WHATSAPP.RETRY.CONFIRM')"
    :is-loading="isRetrying"
    :disable-confirm-button="isRetrying"
    @confirm="handleDialogConfirm"
  />
</template>
